/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalAgreementDraftContentResource } from './';
import {
    LegalAgreementDraftContentResourceFromJSON,
    LegalAgreementDraftContentResourceFromJSONTyped,
    LegalAgreementDraftContentResourceToJSON,
} from './';
import type { LegalAgreementType } from './';
import {
    LegalAgreementTypeFromJSON,
    LegalAgreementTypeFromJSONTyped,
    LegalAgreementTypeToJSON,
} from './';
import type { LegalAgreementVersionResource } from './';
import {
    LegalAgreementVersionResourceFromJSON,
    LegalAgreementVersionResourceFromJSONTyped,
    LegalAgreementVersionResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalAgreementResource
 */
export interface LegalAgreementResource {
    /**
     * 
     * @type {LegalAgreementType}
     * @memberof LegalAgreementResource
     */
    agreementType: LegalAgreementType;
    /**
     * Current draft contents.
     * HTML is stored as authored by Malt admins. User-facing rendering must sanitize or isolate this HTML before injecting it into the DOM.
     * 
     * @type {Array<LegalAgreementDraftContentResource>}
     * @memberof LegalAgreementResource
     */
    draftContents: Array<LegalAgreementDraftContentResource>;
    /**
     * 
     * @type {Array<LegalAgreementVersionResource>}
     * @memberof LegalAgreementResource
     */
    versions: Array<LegalAgreementVersionResource>;
}

/**
 * Check if a given object implements the LegalAgreementResource interface.
 */
export function instanceOfLegalAgreementResource(value: object): value is LegalAgreementResource {
    if (!('agreementType' in value) || value['agreementType'] === undefined) return false;
    if (!('draftContents' in value) || value['draftContents'] === undefined) return false;
    if (!('versions' in value) || value['versions'] === undefined) return false;
    return true;
}

export function LegalAgreementResourceFromJSON(json: any): LegalAgreementResource {
    return LegalAgreementResourceFromJSONTyped(json, false);
}

export function LegalAgreementResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalAgreementResource {
    if (json == null) {
        return json;
    }
    return {
        
        'agreementType': LegalAgreementTypeFromJSON(json['agreementType']),
        'draftContents': ((json['draftContents'] as Array<any>).map(LegalAgreementDraftContentResourceFromJSON)),
        'versions': ((json['versions'] as Array<any>).map(LegalAgreementVersionResourceFromJSON)),
    };
}

export function LegalAgreementResourceToJSON(value?: LegalAgreementResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'agreementType': LegalAgreementTypeToJSON(value['agreementType']),
        'draftContents': ((value['draftContents'] as Array<any>).map((v) => LegalAgreementDraftContentResourceToJSON(v))),
        'versions': ((value['versions'] as Array<any>).map((v) => LegalAgreementVersionResourceToJSON(v))),
    };
}

